import React from 'react';
import {Group, UpdateGroupInput, User} from '../../graphql';
import {CardStyles} from '../Cards/CardStyles';
import {UniversalCard} from '../Cards/UniversalCard';
import {GroupForm} from '../Form/GroupForm';
import {Button, Grid} from '@material-ui/core';

export interface GroupEditViewProps {
  group?: Group;
  updateGroup: Function;
  addUsers: Function;
  removeUsers: Function;
  users: User[];
}

export const GroupEditView = (props: GroupEditViewProps) => {
  const {group, updateGroup, addUsers, removeUsers, users} = props;
  const styles = CardStyles();
  const noUsers = group?.users?.length !== 0 ? <>Click to remove</> :
    <p>No users in group</p>;

  const ids = group?.users?.map((s) => s.id) ?? [];
  const newUsers = users.filter((s) => ids.indexOf(s.id) === -1);
  const noNewUsers = newUsers?.length !== 0 ? <>Click to add</> :
    <p>No remaining users available to add</p>;

  const userList = group?.users
    ?.sort((a, b) => (a.username ?? "") < (b.username ?? "") ? -1 : 1)
    .map((s) =>
      <Button key={s.id} variant="outlined" style={{marginTop: 10, marginRight: 5}} onClick={() => {
        removeUsers({userIds: [s.id]})
      }}>{s.username}</Button>
    );

  const newUserList = newUsers
    .sort((a, b) => (a.username ?? "") < (b.username ?? "") ? -1 : 1)
    .map((s) =>
      <Button key={s.id} variant="outlined" style={{marginTop: 10, marginRight: 5}} onClick={() => {
        addUsers({userIds: [s.id]})
      }}>{s.username}</Button>
    );

  return (
    <Grid container spacing={2} className={styles.pad10}>
      <Grid item md={6} xs={12}>
        <UniversalCard title="Edit Group">
          <GroupForm group={group} onSubmit={(values: UpdateGroupInput) => updateGroup(values)}/>
        </UniversalCard>
      </Grid>
      <Grid item md={6} xs={12}>

        <UniversalCard title="Users">
          {noUsers}
          <div children={userList}></div>
        </UniversalCard>

        <UniversalCard title="Available Users">
          {noNewUsers}
          <div children={newUserList}></div>
        </UniversalCard>

      </Grid>
    </Grid>
  );
};
